import { ReactNode, useEffect } from "react";
import { Title } from "react-head";

import { LayoutContent, useBorderLayout } from "layouts/BorderLayout";
import { useRecentlyViewedPage } from "providers/RecentlyViewed/RecentlyViewedProvider";

import { cx } from "utils";


interface IBorderedPageProps extends LayoutContent {
  title?: ReactNode;
  browserTitle?: string;
  billingData?: any;
  className?: string;
  children?: ReactNode;
}

export default function BorderedPage({
  title,
  browserTitle,
  billingData,
  className,
  children,
  ...props
}: IBorderedPageProps) {
  const recentlyViewedPageContext = useRecentlyViewedPage();

  const { setLayoutContent } = useBorderLayout();

  useEffect(() => {
    setLayoutContent((layoutContent) => ({
      ...layoutContent,
      ...props,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setLayoutContent]); // props is missing from the dependency array by purpose, otherwise the screen will be re-rendered infinitely

  const pageTitle =
    browserTitle ?? (typeof title === "string" ? title : undefined);

  useEffect(() => {
    if (recentlyViewedPageContext && pageTitle) {
      recentlyViewedPageContext.setTitle(pageTitle);
    }
  }, [pageTitle, recentlyViewedPageContext]);


  return (
    <div className={cx("px-2 md:px-8 dark:md:px-6", className)}>
      <Title>ScraperAPI {pageTitle && " | " + pageTitle}</Title>
      { title && <div className="text-2xl py-6 font-semibold">{title}</div> }
      {children}
    </div>
  );
}
